import styled from "styled-components";

import { store } from "store/configureStore";

interface HeadPros {
  bg: string;
}

const Head = styled.section`
  width: 100%;
  background-image: url(${(p: HeadPros) => p.bg});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  min-height: 30px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title-report {
    margin-right: 25px;
    font: normal normal normal 16px/18px MontserratRegular;
    color: #0000008a;
    font-weight: 800;
  }

  .title-report-city {
    margin-right: 25px;
    font: normal normal normal 16px/18px MontserratRegular;
    color: #ffffff;
    font-weight: 800;
  }
`;
interface FilterPros {
  primary?: string;
  bgHeader?: string;
}
const Filter = styled.article`
  z-index: 9999;
  width: 28vw;
  position: relative;
  min-height: 100px;
  max-height: 80vh;

  background: rgba(157, 149, 149, 0.8) 0% 0% no-repeat padding-box;
  
  animation: fade 0.3s linear 0s;
  display: flex;
  flex-direction: column;
  justify-items: center;
  border-radius: 10px;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 0px;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-track:hover,
  ::-webkit-scrollbar-track:active {
    background: transparent;
  }

  .title {
    background-color: ${(p: FilterPros) => p.bgHeader};
    display: flex;
    justify-content: flex-start;
    border-top: 2px;
    border-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: 0.1px;
    padding-top: 5px;
    padding-bottom: 5px;
    span {
      padding: 1px 1px 1px 5px;
      font: normal normal normal 18px/23px MontserratRegular;
      letter-spacing: 0px;
      color: #ffffff;
      text-transform: capitalize;
    }
  }

  .item-input {
    display: flex;
    flex-direction: column;
    padding: 5px 10px 5px 10px;

    .item-control {
      display: flex;
      flex-direction: row;
      justify-items: center;
      align-items: center;
      width: 100%;
      margin-top: 2px;
      margin-bottom: 2px;

      label {
        font-weight: 500;
        padding: 2px;
        font: normal normal normal 14px/22px MontserratRegular;
        letter-spacing: 0.55px;
        width: 100%;
      }
      div {
        width: 20%;
        display: flex;
        justify-items: center;
        align-items: center;
        input,
        select {
          margin: 2px;
          border: 0;
        }
      }
    }

    div > input,
    div > select {
      width: 100%;
      border-radius: 10px;
      padding: 5px;
      border: 0;
      :focus {
        border: 0;
        outline: none;
      }
    }
    div > .select-multi {
      font-size: 0.7rem;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;
    margin-top: 5px;
  }

  @keyframes fade {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 90vw;
    min-height: 60vh;
    max-height: 60vh;
    margin: 0 auto;
    margin-top: 10px;
    
    
  }
`;

interface MultipleProps {
  cbColor: string;
}
const MultipleCombo = styled.div`
  background-color: #fff;
  border-radius: 20px;
  button {
    background-color: #fff;
    border: none;
    width: 100%;
    padding: 5px;
    padding-left: 10px;
    text-align: left;
    border-radius: 20px;
    font-family: MontserratRegular;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    .tags {
      font-size: 10px;
      border-radius: 10px;
      background-color: ${(p: MultipleProps) => p.cbColor};
      color: #fff;
      padding: 4px;
      margin: 4px;
      font-family: MontserratRegular;
      font-weight: bold;
    }
    .tags-plus {
      font-family: MontserratRegular;
      font-size: 10px;
      padding: 4px;
      margin: 4px;
      background-color: #c3c3c3;
      border-radius: 10px;
      color: #fff;
      font-weight: bold;
    }
    .btn-small {
      width: 40px;
      height: 40px;
      left: 90%;
      position: absolute;
    }
  }
  padding-bottom: 5px;

  .options {
    max-height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 10px 2px 10px 15px;
    .option {
      margin: 5px 0 5px 0;
      background-color: #fff;

      .container {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        font-family: MontserratRegular;
        font-size: 12px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #eee;
      }

      .container:hover input ~ .checkmark {
        background-color: #ccc;
      }

      .container input:checked ~ .checkmark {
        background-color: ${(p: MultipleProps) => p.cbColor};
      }

      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      .container input:checked ~ .checkmark:after {
        display: block;
      }

      .container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }
`;

interface ContainerPros {
  display: string;
}

const IframeContainer = styled.iframe`
  position: absolute;
  top: 8%;
  width: 100%;
  height: 85%;
  display: ${(p: ContainerPros) => p.display};
`;

const PowerBiContainer = styled.div`
  display: ${(p: ContainerPros) => p.display};
  justify-items: center;
  justify-content: center;
  width: 100%;
  height: 89vh;

  .iframe-pwbi {
    max-width: 100%;
  }
`;

const AnimationContainer = styled.div`
  display: flex;
  justify-content: center;
  justify-items: center;
  @media (max-width: 850px) and (orientation: landscape) {
    .animation {
      width: 300px;
      height: 266px;
    }
  }
`;

const Container = styled.div`
  overflow: auto;

  &::-webkit-scrollbar {
    width: 10px; /* Ancho del scroll */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 25px 25px;
  }

  @media (max-width: 768px){
    height: 400px;
  }
`;

export {
  Head,
  Filter,
  MultipleCombo,
  IframeContainer,
  PowerBiContainer,
  AnimationContainer,
  Container,
};
